import { FC } from "react";
import orderTranslationsHelper from "../../../../../../../languages/order-translations.helper";
import { OrderDetailsHistoryEntryChangeTargetTaxiEvent } from "../../../common/types/order-details-history-entry-event";

type OrderDetailsHistoryEntryChangeTargetTaxiContentProps = {
  event: OrderDetailsHistoryEntryChangeTargetTaxiEvent;
};

const OrderDetailsHistoryEntryChangeTargetTaxiContentComponent: FC<
  OrderDetailsHistoryEntryChangeTargetTaxiContentProps
> = () => {
  const translations =
    orderTranslationsHelper.getDetailsHistoryTranslations()
      .changeTargetTaxiEntry;

  return (
    <div className="order_details_history_entry_list_item_content">
      <div className="order_details_history_entry_list_item_content__heading_text">
        {translations.headingText}
      </div>
    </div>
  );
};

export default OrderDetailsHistoryEntryChangeTargetTaxiContentComponent;
